var map = {
	"./audio-placeholder": 626,
	"./audio-placeholder.png": 626,
	"./avatar-missing": 367,
	"./avatar-missing.png": 367,
	"./avatar-missing.svg": 822,
	"./halloween/clouds": 627,
	"./halloween/clouds.png": 627,
	"./halloween/halloween-emblem": 639,
	"./halloween/halloween-emblem.svg": 639,
	"./halloween/spider": 640,
	"./halloween/spider.svg": 640,
	"./halloween/spiderweb": 641,
	"./halloween/spiderweb.svg": 641,
	"./halloween/starfield": 642,
	"./halloween/starfield.png": 642,
	"./halloween/twinkle": 643,
	"./halloween/twinkle.svg": 643,
	"./header-missing": 442,
	"./header-missing.png": 442,
	"./soapbox-logo": 443,
	"./soapbox-logo-white": 444,
	"./soapbox-logo-white.svg": 444,
	"./soapbox-logo.svg": 443,
	"./sprite-post-functions": 644,
	"./sprite-post-functions.png": 644,
	"./video-placeholder": 645,
	"./video-placeholder.png": 645,
	"./void": 646,
	"./void.png": 646,
	"./web-push/web-push-icon_expand": 704,
	"./web-push/web-push-icon_expand.png": 704,
	"./web-push/web-push-icon_favourite": 705,
	"./web-push/web-push-icon_favourite.png": 705,
	"./web-push/web-push-icon_reblog": 706,
	"./web-push/web-push-icon_reblog.png": 706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 821;